const handleDatePickerErrorMessage = {
  sendToMaintenanceDateError: 'Seleccione una fecha posterior a la Fecha de envío',
  returnFromMaintenanceDateError: 'Seleccione una fecha posterior a la Fecha de regreso',
};

export default handleDatePickerErrorMessage;